// extracted by mini-css-extract-plugin
export default {"container":"InfoLabel__container___RwpTs","label":"InfoLabel__label____XHej","element":"InfoLabel__element___rjDlY","halfElement":"InfoLabel__halfElement___BI_TP"};